import React, { FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
const Desktop: FC<HTMLAttributes<HTMLDivElement>> = ({
  ...rest
}) => <DesktopWrapper {...rest} />;
export default Desktop;
const DesktopWrapper = /*#__PURE__*/styled('div')({
  name: "DesktopWrapper",
  class: "drcnd1g",
  propsAsIs: false
});

require("./Desktop.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Desktop.tsx");